import {
  useElement,
  usePlateEditorRef,
  getTableRowIndex,
  useTableStore,
  getTableCellBorders,
  useIsCellSelected,
  ELEMENT_TABLE,
  ELEMENT_TR,
} from '@udecode/plate';
import { useReadOnly } from 'slate-react';

import { getTableColumnIndex } from './utils/getTableColumnIndex';

export const useTableCellElementState = ({
  ignoreReadOnly,
} = {}) => {
  const editor = usePlateEditorRef();
  const cellElement = useElement();
  const { colSpan = 0 } = cellElement;

  const colIndex = getTableColumnIndex(editor, cellElement);
  const rowIndex = getTableRowIndex(editor, cellElement);

  const readOnly = useReadOnly();

  const isCellSelected = useIsCellSelected(cellElement);
  const hoveredColIndex = useTableStore().get.hoveredColIndex();

  const tableElement = useElement(ELEMENT_TABLE);
  const rowElement = useElement(ELEMENT_TR);
  const rowSizeOverrides = useTableStore().get.rowSizeOverrides();
  const rowSize =
    rowSizeOverrides.get(rowIndex) ?? rowElement?.size ?? undefined;

  const isFirstCell = colIndex === 0 || colIndex === colSpan - 1;
  const isFirstRow = tableElement.children[0] === rowElement;

  const borders = getTableCellBorders(cellElement, {
    isFirstCell,
    isFirstRow,
  });

  return {
    colIndex,
    rowIndex,
    readOnly: !ignoreReadOnly && readOnly,
    selected: isCellSelected,
    hovered: hoveredColIndex ===  colIndex,
    hoveredLeft: isFirstCell && hoveredColIndex === -1,
    rowSize,
    borders,
  };
};
